// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

function t(backgroundColorOpt, colorOpt, iconColorOpt, param) {
  var backgroundColor = backgroundColorOpt !== undefined ? backgroundColorOpt : Theme__Color$PrezzeeRibbon.lilac400;
  var color = colorOpt !== undefined ? colorOpt : Theme__Color$PrezzeeRibbon.purple400;
  var iconColor = iconColorOpt !== undefined ? iconColorOpt : Theme__Color$PrezzeeRibbon.purple400;
  return {
          backgroundColor: backgroundColor,
          color: color,
          iconColor: iconColor
        };
}

export {
  t ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
